import React, { Fragment, useState } from "react";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
// import Paper from '@mui/material/Paper';
//import Logo from "../images/logo-bluetext.png"
import Box from '@mui/material/Box';
import { GetAccessToken, fetcher } from "../components/Dashboard/Utilities";
import useSWR from 'swr';
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "../components/Widgets/TransparentLoadingDisplay"
// import { InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
// import { Controller } from "react-hook-form";
// import FormControl from '@mui/material/FormControl';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
import NativeSelect from "@material-ui/core/NativeSelect";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import { Marker } from "react-mark.js";
import { useMarker } from "react-mark.js";
import Mark from "mark.js";
import TextField from '@mui/material/TextField';



export default function SDReport() {

    let { tenantIdent } = useParams();
    
    const Print = () => {
        //console.log('print');  
        let printContents = document.getElementById('printablediv').innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(false);
    }


    const setHiglightText = (text) => {
        //debugger;
        var element = document.querySelector("#search-node");
        var markInstance = new Mark(element);
        //this.markInstance = new Mark(document.querySelector("#search-node"));
        markInstance.unmark();
        markInstance.mark(text);


    };



    const [reportDescription, setReportDescription] = useState('');

    //const [grade, setGrade] = React.useState('0');
    ///const [selectedGrade, setSelectedGrade] = React.useState('0');
    //const [selectedGradeName, setSelectedGradeName] = React.useState('');
    //const [gradeList, setGradeList] = React.useState();
    const [reportData, setReportData] = React.useState('');

    //const [logoFile, setLogoFile] = React.useState();
    debugger;
    var fetchUrl = '';
    //if (tenantIdent !== undefined) {

        fetchUrl = 'reports/getApprovedPias?tenantIdent=' + tenantIdent;
    //}

    if (reportData === '') {
        var result = fetch(fetchUrl,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                // withCredentials: true,
                // credentials: 'include',
                // headers: {
                //     'Authorization': bearer,
                //     'Content-Type': 'application/json'
                // }
            }
        ).then(data => data.json()).then(
            (data) => {
                //debugger;
                console.log(data);
                setReportData(data);
                setReportDescription('This report displays the approved PIAs for ' + data.tenantName + '.');
            },
            (error) => {
                // setLoading(false);
                //setError(error);
            }
        );
    }

    if (reportData === '') {
        return (

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }


    async function FetchReportData(grade, accessToken) {

        //var accessTokenbearer = 'Bearer ' + accessToken;
        //var token = accessToken;
        //console.log(accessToken);

        var url = 'reports/getPIReportdata?gradeYear=' + grade;
        if (tenantIdent !== undefined) {


            url = 'reports/getGradeLeveldata?gradeYear=' + grade + '&tenantId=' + tenantIdent;
        }



        var result = await fetch(url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },

            }
        ).then(data => data.json()).then(
            (data) => {
                return (data);
            },
            (error) => {
                // setLoading(false);
                //setError(error);
            }
        );
        return result;
    }

    function handleGradeChange(event, data) {

        var selectedValue = event.target.value;
        var index = event.nativeEvent.target.selectedIndex;
        var selectedGradeName = event.nativeEvent.target[index].text;



        FetchReportData(event.target.value).then((reportData) => {
            setReportData(reportData);
            setReportDescription('This report outlines the personal information (PI) that ' + reportData.tenantName + ' has shared with application vendors in order to support the student learning experience. All the vendors listed below have been through a Privacy Impact Assessment (PIA) before any student personal information was shared with them.  The school\'s process for evaluating and using software complies with provincial and federal regulatory requirements. Only the minimum and necessary PI is shared with vendors, the PI is only used for the purposes for which it is collected and there are processes in place for personal information to be secured and removed from these vendors when the appliation is no longer required to support the student. This report does not include personal information that has been gathered about a student through the admissions and re-registration processes.  It does not include personal information that has been gathered or created as part of the student\'s education at the school such as (but not limited to):  student assessment and evaluation and student support data. The sharing of this personal information is governed by the provincial/state bodies through their particular education legislation. For questions about this report, please contact ' + reportData.poname + '.');
        });

    };

    function joinValues(arrayToJoin) {
        if (arrayToJoin !== null) {
            return arrayToJoin.join(', ');
        }
        return '';
    }




    return (


        <Fragment>
            <Grid style={{ width: '100%' }} container spacing={3} paddingBottom={5}>

                <Grid item xs={1}>


                    <div >
                        <Button variant="outlined" onClick={Print}>Print</Button>
                    </div>

                </Grid>
                <Grid item xs={6}>
                    <TextField
                        // disabled={!currentUser.isSuperAdmin}
                        style={{ marginTop: '0px' }}
                        id="nameFilter"
                        name="url"
                        label="Begin Typing to highlight text in report."
                        fullWidth
                        margin="dense"
                        onChange={(e) => setHiglightText(e.target.value)}

                    />
                </Grid>
            </Grid>

            <div id='printablediv'>
                <div id='search-node' >
                    <Grid style={{ width: '100%' }} container spacing={3}>

                        <Grid item xs={12}>
                            <Box bgcolor={'#E4E4E4'}
                                component="img"
                                sx={{
                                    height: 64,
                                    //maxWidth:100,
                                }}
                                alt="Your logo."
                                src={"../images/" + reportData.logofile}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <Typography align="center" variant="h5" component="h2">
                                Approved Software Report
                            </Typography>
                        </Grid>
                        <Grid item xs={2} />
                        <Grid item xs={2} >

                        </Grid>
                        <Grid item xs={8}>
                            <Typography >
                                {/* This report outlines the personal information (PI) that {data.tennantName} has shared with application vendors in order to support the sudent learning experience. All the vendors listed below have been through a Privacy Impact Assessment (PIA) before any student personal information was shared with them.  The school's process for evaluating and using software complies with provincial and federal regulatory requirements. Only the minimum and necessary PI is shared with vendors, the PI is only used for the purposes for which it is collected and there are processes in place for personal information to be secured and removed from these vendors when the appliation is no longer required to support the student. This report does not include personal information that has been gathered about a student through the admissions and re-registration processes.  It does not include personal information that has been gathered or created as part of the student's education at the school such as (but not limited to):  student assessment and evaluation and student support data. The sharing of this personal information is governed by the provincial/state bodies through their particular education legislation. For questions about this report, please contact {data.tennantPrivacyOfficer} */}
                                {reportDescription}
                            </Typography>
                        </Grid>

                        <Fragment>
                            <Grid item xs={3} >
                                <Typography >
                                    Date Created: {new Date().toLocaleString() + ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} >
                                {/* <Typography >
                                    Grade Selected: {selectedGradeName}
                                </Typography> */}
                            </Grid>

                            <Grid item xs={12} >
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Grade Level(s)</TableCell>
                                            <TableCell>Application Name</TableCell>
                                            <TableCell>URL</TableCell>
                                            <TableCell>Description</TableCell>
                                            {/* <TableCell>Student Information</TableCell> */}
                                            {/* <TableCell>Notes</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    {!(typeof reportData === 'undefined') &&
                                        <TableBody>
                                            {reportData.pias.map((row) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.gradeLevels}</TableCell>
                                                    <TableCell>{row.name}</TableCell>
                                                    <TableCell>{row.url}</TableCell>
                                                    <TableCell>{row.description}</TableCell>
                                                    {/* <TableCell>{joinValues(row.studentInfoSelected)}</TableCell> */}
                                                    {/* <TableCell align="right"></TableCell> */}
                                                </TableRow>
                                            ))}
                                        </TableBody>}
                                </Table>
                            </Grid>
                        </Fragment>


                    </Grid >
                    <Grid item xs={12} />


                </div>
            </div>

        </Fragment>




    )
}